const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurma`, params);
    },
    $obterRelatorioLogCSVTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurmaCsv`, params);
    },
    $obterRelatorioLogPDFTurma(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurmaPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
